import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import storage from '../../api/storage';
import { Container } from '../../../ui/gridSystem';
import { NoResult, Text } from '../../../ui/atoms';
import { Table } from './style';
import { GLOBAL_COURSE_LIST_GET } from '../../redux/actions/courselist';
import { objectArraySorting } from '../../../utils/common';

const DownloadCatalog = ({ courseList, moduleList, getCourseList }) => {
  const [filters, setFilters] = useState({});
  const [orderedList, setOrderedList] = useState({});

  useEffect(() => {
    const activeTab = storage.read('activeTab')?.value;
    const storageFilters =
      storage.read(activeTab === 'modules' ? 'moduleFilters' : 'courseFilters')
        ?.value || {};
    setFilters(storageFilters);
  }, []);

  useEffect(() => {
    if (Object.keys(filters)?.length > 0) {
      const parsedFilters = {
        ...filters,
        page: -1,
      };
      getCourseList(parsedFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  useEffect(() => {
    const activeTab = storage.read('activeTab')?.value;
    let newList;
    if (activeTab === 'modules') {
      newList = [...moduleList];
    } else {
      newList = [...courseList];
    }
    objectArraySorting(newList, 'course_category');
    const categories = [];
    newList.forEach((item) => {
      if (!categories?.includes(item?.course_category)) {
        categories.push(item?.course_category);
      }
    });
    const newOrderedList = {};
    (categories || []).forEach((c) => {
      newOrderedList[c] = newList.filter((item) => item?.course_category === c);
    });
    setOrderedList(newOrderedList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseList, moduleList]);

  const [firstRender, setFirstRender] = useState(true);
  useEffect(() => {
    if (firstRender && Object.keys(orderedList)?.length > 0) {
      setTimeout(() => {
        window.print();
        setTimeout(window.close, 0);
        // wait for data to load
      }, 300);
      setFirstRender(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderedList]);

  return (
    <Container>
      <Text type="h2">Catalogo corsi</Text>
      {Object.keys(orderedList)?.map((c) => (
        <React.Fragment key={`section-${c}`}>
          <Text type="h2.5" mt={22}>
            Area tematica: "{c}"
          </Text>
          <Table>
            <thead>
              <tr>
                <th>
                  <Text type="h3.5">Codice</Text>
                </th>
                <th>
                  <Text type="h3.5">Titolo</Text>
                </th>
                <th>
                  <Text type="h3.5">Materia</Text>
                </th>
              </tr>
            </thead>
            <colgroup>
              <col span="1" style={{ width: '15%' }} />
              <col span="1" style={{ width: '55%' }} />
              <col span="1" style={{ width: '30%' }} />
            </colgroup>
            <tbody>
              {(orderedList[c] || []).map((item, i) => (
                <tr key={`course-${i}`}>
                  <td>
                    <Text type="b4" className="code">
                      {item?.course_code}
                    </Text>
                  </td>
                  <td>
                    <Text type="h3.5" className="line-clamp">
                      {item?.course_title}
                    </Text>
                  </td>
                  <td>
                    <Text type="b4">{item?.course_category}</Text>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </React.Fragment>
      ))}
      {orderedList?.length === 0 && <NoResult />}
    </Container>
  );
};

DownloadCatalog.propTypes = {
  courseList: PropTypes.array,
  moduleList: PropTypes.array,
  getCourseList: PropTypes.func,
};

export default connect(
  (state) => {
    const { list: courseList } = state.courselist.courses;
    const { list: moduleList } = state.courselist.modules;
    return { courseList, moduleList };
  },
  (dispatch) => ({
    getCourseList: (filters) =>
      dispatch({
        type: GLOBAL_COURSE_LIST_GET._REQUEST,
        filters,
      }),
  })
)(DownloadCatalog);
